import { SET_CANCEL_SOURCE, RESET_CANCEL_SOURCE } from "../types";

export const setCancelSource = cancelSource => ({
  type: SET_CANCEL_SOURCE,
  cancelToken: cancelSource
});

export const resetCancelSource = () => ({
  type: RESET_CANCEL_SOURCE
});

export const setApiCancelToken = cancelSource => dispatch => {
  dispatch(setCancelSource(cancelSource));
};

export const resetApiCancelSource = () => dispatch => {
  dispatch(resetCancelSource());
};



// WEBPACK FOOTER //
// ./src/actions/apiCancelSource.js